// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Limits page styles */

/* Filter tabs - matching project pattern */
.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

/* Grouped limits display */
.limits-grouped {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.limits-group .group-header {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 10px 0;
}

/* Badges */
.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

/* Icon buttons */
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.2s ease, color 0.2s ease;
}

.icon-btn.edit {
  color: #5865f2;
}

.icon-btn.edit:hover {
  background: rgba(88, 101, 242, 0.15);
}

.icon-btn.delete {
  color: #f04747;
}

.icon-btn.delete:hover {
  background: rgba(240, 71, 71, 0.15);
}

.actions-cell {
  display: flex;
  gap: 5px;
}

/* Slider */
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: #40444b;
  outline: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
  border: none;
}

/* Shared styles (page-header, modal, etc. inherited from other loaded CSS) */
.no-data {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Limits.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,2CAA2C;AAC3C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Limits page styles */\n\n/* Filter tabs - matching project pattern */\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n/* Grouped limits display */\n.limits-grouped {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.limits-group .group-header {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n}\n\n/* Badges */\n.badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* Icon buttons */\n.icon-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.icon-btn.edit {\n  color: #5865f2;\n}\n\n.icon-btn.edit:hover {\n  background: rgba(88, 101, 242, 0.15);\n}\n\n.icon-btn.delete {\n  color: #f04747;\n}\n\n.icon-btn.delete:hover {\n  background: rgba(240, 71, 71, 0.15);\n}\n\n.actions-cell {\n  display: flex;\n  gap: 5px;\n}\n\n/* Slider */\n.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: #40444b;\n  outline: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n  border: none;\n}\n\n/* Shared styles (page-header, modal, etc. inherited from other loaded CSS) */\n.no-data {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
